<div class="ttmodal">
  <div style="margin-left: 39%;" *ngIf="DigtalFormOverview == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>
  <div class="ttmodal__header"  *ngIf="DigtalFormOverview != null">
      <span class="ttmodal__title">Category: {{parentCatName}} | Section: {{qCategoryName}}</span>
      <a class="button waves-effect" (click)="onCloseClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">Close</span>
      </a>
  </div>
  <div class="ttmodal__body" *ngIf="DigtalFormOverview != null">
  <div class="page-padding">
  <div style="margin-bottom: 2%;">
    <div style="display: flex;">
      <div *ngIf="fq.QuestionTypeId!=6" style="padding: 1%; width: 40%; background: white;margin-top: 1%;">
        <div style="display: flex;flex-direction: column;">
          <span class="panel__header__title"><b>Instructions</b></span>
          <span class="panel__header__title">{{fq.QDescription}}</span>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div *ngIf="fq.HasQuestionImage==true" style="display:flex;flex-direction:row;font-size: 14px;">
            <img id="img_{{fq.QuestionId}}" style='display:block; width: 250px;' [src]="getImage(fq.QuestionImage)" />
          </div>
          <div *ngIf="fq.HasQuestionImage==false" style="display:flex;flex-direction:row;font-size: 14px;">
            <img id="img_{{fq.QuestionId}}" style='display:block; width: 250px;'
              src="/Content/Images/NO-IMAGE_Sample.jpg" />
          </div>
          <div *ngIf="fq.EditedQuestionImage == '' ||  fq.EditedQuestionImage == null"
            style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2%">
            <img id="Editimg_{{fq.QuestionId}}" style='display:none; width: 250px;' />
          </div>
          <div *ngIf="fq.EditedQuestionImage != '' && fq.EditedQuestionImage != null"
            style="display:flex;flex-direction:row;font-size: 14px;     margin-left: 1%;">
            <img id="Editimg_{{fq.QuestionId}}" style='display:block; width: 250px;'
              [src]="getImage(fq.EditedQuestionImage)" />
          </div>
        </div>
        <ng-container *ngIf="fq.ImageEdit" style="display: none;">
          <div>
            <a class="button button--primary" (click)="EditImage(fq.QuestionId,fq.QuestionImage, fq)">
              <span class="button__text">Edit Image</span>
              <i class="material-icons button__icon">brush</i></a>
          </div>
        </ng-container>
      </div>
      <div *ngIf="fq.QuestionTypeId==6" style="padding: 1%; width: 50%; background: white;margin-top: 1%;">
        <div style="display:flex;flex-direction:column;font-size: 14px;">
          <div style="display: flex; flex-direction: row;    width: min-content;">
            <div style="display: flex; flex-direction: row; ">
              <span style="align-self: center;min-width: 118px;">Fixed</span>
              <mat-checkbox [(ngModel)]="FixedCracks" (change)="FilterObs()"
                style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
              </mat-checkbox>
            </div>
            <div style="display: flex; flex-direction: row; margin-left: 35%;">
              <span style="align-self: center;min-width: 118px;">Un-Repaired</span>
              <mat-checkbox [(ngModel)]="NotFixedCracks" (change)="FilterObs()"
                style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
              </mat-checkbox>
            </div>
            <div style="display: flex; flex-direction: row;margin-left: 29%;min-width: max-content;">
              <span style="align-self: center;min-width: 118px;cursor: pointer;" (mouseenter)="mouseOverAction()"
                (mouseleave)="mouseleaverAction()"><u>Colour Legend for Points</u> </span>
            </div>
            <!-- <div>
            <a  class="tooltip" style="cursor: pointer;"> Legend
             <span>
              <img class="callout"  src="/Content/Images/ledgend.png" />
             </span>
          </a>
            </div> -->
          </div>
          <img *ngIf="fq.SchematicList==null" style='display:block; width: 250px;'
            src="/Content/Images/NO-IMAGE_Sample.jpg" />
          <div style="position: relative;">
            <img class="schematicImage" [src]="getImage(schematicImage)">
            <ng-container *ngFor="let cp of obsDetails">
              <i class="material-icons button__icon component-dot2" style="line-height: 0;"
                matTooltip={{cp.ObservationPointName}} (click)="SelectObPoint(cp)"
                [class.red-eval]="(cp.pointLedgend==1 || (cp.isCrackFixed==false && cp.observationPointTypeId==2))"
                [class.no-eval]="cp.pointLedgend==5" [class.green-eval]="cp.pointLedgend==3"
                [class.purple-eval]="cp.pointLedgend==2" [class.selectedobl]="cp.selected==true"
                [class.blue-eval]="cp.isCrackFixed==true"
                [style]="getPosition(cp.ObservationPointPosX, cp.ObservationPointPosY)"> lens</i>
              <i class="material-icons button__icon component-dot2" style="line-height: 0;"
                *ngIf="cp.EndObservationPointPosY!=null" matTooltip={{cp.ObservationPointName}}
                (click)="SelectObPoint(cp)"
                [class.red-eval]="(cp.pointLedgend==1 || (cp.isCrackFixed==false && cp.observationPointTypeId==2))"
                [class.no-eval]="cp.pointLedgend==5" [class.green-eval]="cp.pointLedgend==3"
                [class.purple-eval]="cp.pointLedgend==2" [class.selectedobl]="cp.selected==true"
                [class.blue-eval]="cp.isCrackFixed==true"
                [style]="getPosition(cp.EndObservationPointPosX, cp.EndObservationPointPosY)"> lens</i>
              <div *ngIf="cp.EndObservationPointPosY!=null"
                [style]="getLine(cp.ObservationPointPosX, cp.ObservationPointPosY,cp.EndObservationPointPosX, cp.EndObservationPointPosY,cp.isCrackFixed)">
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div style="padding: 1%; width: 55%; background: white;margin-top: 1%; margin-left: 1%;">
        <!-- <div style="display: flex; flex-direction: column;"> -->
        <div>
          <div style=" display: flex;justify-content: space-between;">
            <span *ngIf="fq?.QuestionTypeId!=6" class="panel__header__title"><b> Question : {{fq?.QTitle}}<span *ngIf="isAnswerMandatory"> * </span></b></span>
            <span *ngIf="fq?.QuestionTypeId==6  && selectedObservationPoint?.ObservationPointQuestionTitle==null"
              class="panel__header__title" style="max-width: 65%;"><b> Question: {{fq?.QTitle}}</b></span>
            <span *ngIf="fq.QuestionTypeId==6 && selectedObservationPoint?.ObservationPointQuestionTitle!=null"
              class="panel__header__title" style="max-width: 65%;"><b> Question: {{
                selectedObservationPoint?.ObservationPointQuestionTitle}}</b></span>
            <div style="display: flex;" *ngIf="fq.QuestionTypeId!=6">
              <a [matMenuTriggerFor]="flagtypes" [ngClass]="{'disabled-link': !diabledFlag}">
                <i class="material-icons button__icon" style="font-size: 28px; vertical-align: middle;cursor: pointer;"
                  [style.color]="GetColor()">flag</i>
                <mat-menu #flagtypes="matMenu">
                  <span mat-menu-item style="font-weight: bold;">Select Flag Type</span>
                  <ng-container *ngFor="let type of flagTypes">
                    <div style="display: flex;flex-direction: row-reverse;">
                      <i class="material-icons button__icon"
                        style="font-size: 28px; vertical-align: middle;cursor: pointer; margin-top: 5%"
                        [style.color]="type.Color">flag</i>
                      <button mat-menu-item (click)="UpdateFlag(type,fq)">{{type.Name}}</button>
                    </div>
                  </ng-container>
                  <button *ngIf="isSupervisour==true && fq.QuestionFlag>0" mat-menu-item (click)="CompleteFlag()">Clear
                    Flag</button>
                </mat-menu>
              </a>
              <i *ngIf="isSupervisour==true" class="material-icons button__icon"
                style="font-size: 28px; vertical-align: middle;cursor: pointer;"
                (click)="OpenFlagComment()">live_help</i>
            </div>
            <div style="display: flex;" *ngIf="fq.QuestionTypeId==6">
              <a [matMenuTriggerFor]="flagtypes">
                <i class="material-icons button__icon" style="font-size: 28px; vertical-align: middle;cursor: pointer;"
                  [style.color]="GetObsFlagColor()">flag</i>
                <mat-menu #flagtypes="matMenu">
                  <span mat-menu-item style="font-weight: bold;">Select Flag Type</span>
                  <ng-container *ngFor="let type of flagTypes">
                    <div style="display: flex;flex-direction: row-reverse;">
                      <i class="material-icons button__icon"
                        style="font-size: 28px; vertical-align: middle;cursor: pointer; margin-top: 5%"
                        [style.color]="type.Color">flag</i>
                      <button mat-menu-item (click)="UpdateFlagObs(type)">{{type.Name}}</button>
                    </div>
                  </ng-container>
                  <button *ngIf="isSupervisour==true" mat-menu-item (click)="CompleteFlagObs()">Clear Flag</button>
                </mat-menu>
              </a>
              <i *ngIf="isSupervisour==true" class="material-icons button__icon"
                style="font-size: 28px; vertical-align: middle;cursor: pointer;"
                (click)="OpenObsFlagComment()">live_help</i>
            </div>
            <div *ngIf="fq.QuestionTypeId==6">
              <!-- <a *ngIf="showobprev" class="button button--primary" style="background-color: white;" [disabled]="loadingobs" (click)="LoadPreviousObs()">
                <span class="button__text" style="color: black"> Prev. Point</span>
              </a>
              <a  *ngIf="showobnext" class="button button--primary" style="background-color: white;"  [disabled]="loadingobs" (click)="LoadNextObs()">
                <span class="button__text" style="color: black"> Next. Point</span>
              </a> -->
              <button *ngIf="obsDetails.length>1" class="button button--primary" [class.loading]="loadingobs"
                (click)="LoadPreviousObs()">
                <span class="button__text" style="color: black"> Prev. Point</span>
              </button>
              <button *ngIf="obsDetails.length>1" class="button button--primary" [class.loading]="loadingobs"
                (click)="LoadNextObs()">
                <span class="button__text" style="color: black"> Next. Point</span>
              </button>
            </div>
          </div>
          <div>
            <ng-container *ngIf="fq.ModelAnswers.length > 1">
              <ng-container *ngIf="fq.QuestionTypeId == 1">
                <div style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <mat-radio-group style="display: flex;flex-direction: column;">
                    <mat-radio-button *ngFor="let answers of fq.ModelAnswers" [value]="answers"
                      (change)="SelectAnswerRadio($event,answers.AnswerId,fq)" [checked]="answers.select">
                      <span>{{answers.Answer}}</span></mat-radio-button>
                  </mat-radio-group>
                </div>
              </ng-container>
              <ng-container *ngIf="fq.QuestionTypeId == 2">
                <div style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <mat-radio-group style="display: flex;flex-direction: column;">
                    <mat-radio-button *ngFor="let answers of fq.ModelAnswers" [value]="answers"
                      (change)="SelectAnswer($event,answers.AnswerId,fq)" [checked]="answers.select">
                      <span>{{answers.Answer}}</span></mat-radio-button>
                  </mat-radio-group>
                </div>
              </ng-container>
              <ng-container *ngIf="fq.QuestionTypeId == 3">
                <div style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <ng-container *ngFor="let answers of fq.ModelAnswers">
                    <mat-checkbox id="check_{{answers.AnswerId}}" [(ngModel)]="answers.select" (change)="ChangeFlag()">
                      <span>{{answers.Answer}}</span>
                    </mat-checkbox>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="fq.ModelAnswers.length == 1">
              <ng-container *ngIf="fq.QuestionTypeId == 4">
                <textarea style="width: 50%;" id="freetext_{{fq.QuestionId}}" class="textAreaComment" rows="4"
                  maxlength="256" [(ngModel)]="fq.ModelAnswers[0].Answer" (change)="UpdateFreetextOrNumber($event,fq)"
                  placeholder="Answer"></textarea>
              </ng-container>
              <ng-container *ngIf="fq.QuestionTypeId == 5">
                <div class="row">
                  <div class="col-md-3">
                    <input type="number" id="numerical_{{fq.QuestionId}}" class="get-Input"
                      [(ngModel)]="fq.ModelAnswers[0].Answer" (change)="UpdateFreetextOrNumber($event,fq)"
                      placeholder="Answer">
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="fq.QuestionTypeId == 6">
              <ng-container *ngIf="selectedObservationPoint!=null">
                <div style="margin-top: 1%;">
                  <div>
                    <div style="display: flex; flex-direction: row;justify-content: space-between;">
                      <ng-container *ngIf="selectedObservationPoint.observationPointTypeId==2">
                        <span *ngIf="PrefUOM==1"><b>Obervation Point:</b>
                          {{selectedObservationPoint.ObservationPointName}} -
                          {{selectedObservationPoint.measurement=='0'?'':selectedObservationPoint.measurement }}
                          mm</span>
                        <span *ngIf="PrefUOM==2"><b>Obervation Point:</b>
                          {{selectedObservationPoint.ObservationPointName}} -
                          {{selectedObservationPoint.measurement=='0'?'':(selectedObservationPoint.measurement/25.4).toFixed(1)
                          }} inch</span>
                      </ng-container>
                      <ng-container *ngIf="selectedObservationPoint.observationPointTypeId!=2 ">
                        <span><b>Obervation Point:</b> {{selectedObservationPoint.ObservationPointName}}</span>
                      </ng-container>
                      <i *ngIf="selectedObservationPoint.ObservationPointQuestionInstruction!=null"
                        class="material-icons button__icon"
                        style="font-size: 32px; vertical-align: middle;cursor: pointer;"
                        (click)="OpenInstructions(selectedObservationPoint.ObservationPointQuestionInstruction)">build_circle</i>
                    </div>
                  </div>
                  <div style="margin-top: 1%; display: flex;"
                    *ngIf="selectedObservationPoint.observationPointTypeId!=3 && selectedObservationPoint.observationPointTypeId!=4 ">
                    <span style="width: 135px;">Reading Number</span>
                    <select (change)="ChangeReadingNum($event)" [(ngModel)]="ReadingNum" class="get-Input">
                      <option *ngFor="let  point of observationpointMeasurements" value={{point.ReadingNumber}}>
                        {{point.ReadingNumber}}</option>
                    </select>
                  </div>
                  <div style="margin-top: 1%;   display: flex;"
                    *ngIf="selectedObservationPoint.observationPointTypeId!=3 && selectedObservationPoint.observationPointTypeId!=4">
                    <!-- <select  (click)="ChangeUnitType($event)" class="get-Input" [(ngModel)]="selectedUOM" id="uom_" name="uomtype">
                        <option value="1">MM</option>
                        <option  value="2">INCH</option>
                      </select> -->
                    <span style="width: 135px;">Measurement</span>
                    <input type="number" style="width: 50%;" class="get-Input"
                      [(ngModel)]="measurement==-99?null:measurement" (change)="UpdateMeasurement($event)"
                      placeholder="Measurement">
                    <span style="align-self: center;">{{UOMLabel}}</span>
                  </div>
                  <div style="margin-top: 1%;display: flex;" *ngIf="selectedObservationPoint.observationPointTypeId==2">
                    <span style="width: 135px;">Crack Status</span>
                    <select (change)="ChangeCackStatu($event)" [(ngModel)]="crackStatus" class="get-Input">
                      <option value="1">Un-Repaired</option>
                      <option value="2">Repaired</option>
                    </select>
                  </div>
                  <div style="margin-top: 1%;" *ngIf="selectedObservationPoint.observationPointTypeId==3">
                    <span>Select Evaluation</span>
                    <select (change)="SelectEvaluation($event)" [(ngModel)]="eval" class="get-Input">
                      <option value="1">A</option>
                      <option value="2">B</option>
                      <option value="3">C</option>
                      <option value="4">X</option>
                    </select>
                  </div>
                  <div style="margin-top: 1%;" *ngIf="selectedObservationPoint.observationPointTypeId==4">
                    <span>Select Evaluation</span>
                    <select (change)="SelectEvaluation($event)" [(ngModel)]="eval" class="get-Input">
                      <option value="1">Accepted</option>
                      <option value="2">Monitor</option>
                      <option value="4">Not Accepted</option>
                    </select>
                  </div>
                </div>
                <div style="    margin-right: 10%;margin-top: 3%;">
                  <mat-icon style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
                    (click)="openSchematicWindow(schematicImage,fq)">add_location_alt</mat-icon>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div *ngIf="UpdateExsitingAnswer">
            <span style="color: red;"> There is an existing answer and new answer is being added to the comment field
              and the form supervisor will be informed.</span>
          </div>
          <div *ngIf=" fq.QuestionTypeId != 6"
            style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 3%;">
            <textarea style="width: 60%;" id="questionComment_{{fq.QuestionId}}" rows="4"
              [(ngModel)]="fq.QuestionComment" (change)="ChnageFlag()" class="textAreaComment" maxlength="256"
              placeholder="Comment or reason for cannot complete"></textarea>
                  <!-- add by rakesh -->
            <!-- <div style="display: flex; flex-direction: column; padding-left: 10px;"> -->
              <div style="display: flex; flex-direction: column; padding-left: 10px; min-width: 320px;">
              <div style="display: flex; flex-direction: row; gap: 15px;">
              <!-- <div  style="display: flex; flex-direction: row;"> -->
                <div *ngIf="fq.QuestionTypeId==5">
                  <span class="panel__header__title" ><b> # Dec. Places</b></span>
                    <input type="number" id="numerical_{{fq.QuestionId}}" class="get-Input-90"
                    [(ngModel)]="fq.ModelAnswers[0].DecimalPlaces" (change)="UpdateFreetextOrNumber($event,fq)" disabled>
                </div>
                <div *ngIf="fq.QuestionTypeId==5 && fq.IsActiveLimit">
                  <span class="panel__header__title" ><b> # 0% Limit</b></span>
                    <input type="number" id="numerical_{{fq.QuestionId}}" class="get-Input-90"
                    [(ngModel)]="fq.ModelAnswers[0].StartWorn" (change)="UpdateFreetextOrNumber($event,fq)" disabled>
                </div>
                <div *ngIf="fq.QuestionTypeId==5 && fq.IsActiveLimit">
                  <span class="panel__header__title" ><b> # 100% Limit</b></span>
                    <input type="number"  id="numerical_{{fq.QuestionId}}" class="get-Input-90"
                    [(ngModel)]="fq.ModelAnswers[0].EndWorn" (change)="UpdateFreetextOrNumber($event,fq)" disabled>
                </div>
              </div>
              <div style="display: flex; flex-direction: column;  padding-top: 20px;" >
                <mat-checkbox [(ngModel)]="fq.UnableToComplete" (change)="ChangeFlagToActionRequied()"> Unable to Complete</mat-checkbox>
                  &nbsp;&nbsp;
                <mat-checkbox [(ngModel)]="fq.WorkInProgress" (change)="ChangeFlagToActionRequiedWIP()"> Work in Progress</mat-checkbox>
              
              </div>
            </div>
                  
                <!-- add by rakesh -->
          </div>
          <div *ngIf=" fq.QuestionTypeId == 6 && selectedObservationPoint!=null"
            style="display: flex; flex-direction: column; justify-content: space-between;margin-top: 3%;">
            <textarea style="width: 60%;" rows="4" [(ngModel)]="obsComment" (change)="ChangeComment()"
              class="textAreaComment" maxlength="256" placeholder="Comment"></textarea>
            <mat-checkbox id="check_{{selectedObservationPoint.ObservationPointId}}"
              [(ngModel)]="selectedObservationPoint.obsUnabletoComplete" (change)="UpdateObsUnable($event)"> Unable to Complete</mat-checkbox>
            <mat-checkbox id="check_WIP{{selectedObservationPoint.ObservationPointId}}"
              [(ngModel)]="selectedObservationPoint.obsWorkInProgress" (change)="UpdateObsWIP($event)"> Work in Progress</mat-checkbox>
          </div>
        </div>
        <div style="padding: 1%; width: 50%; background: white;margin-top: 1%; margin-left: 1%; width: auto;">
          <ng-container *ngIf="fq.AllowImages && fq.QuestionTypeId != 6">
            <span class="panel__header__title"><b>Images</b></span>
            <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap;margin-top: 5%; ">
              <input hidden type='file' accept="image/*" (change)="onSelectPhoto($event, fq)" #uploadImage>
              <ng-container>
                <div class="add-new-schematic" (click)="uploadImage.click()"
                  style="float: left; margin-right: 1%; cursor: pointer;" matTooltip="Click to upload a image">
                  <i class="material-icons add-new-schematic__icon">add_box</i>
                  <div class="add-new-schematic__text">Add Image</div>
                </div>
                <ng-container *ngIf="fq.UploadImages!=null">
                  <ng-container *ngFor="let img of fq.UploadImages">
                    <img [src]="getImage(img)" class="selection__image" (click)="openUploadEditImage(img)"
                      style="width: 100px;     cursor: pointer;" />

                    <mat-icon style="margin-left: 14px; cursor: pointer;"
                      (click)="deleteimage(img,fq)">delete</mat-icon>
                  </ng-container>
                </ng-container>
                <div id="ulSchematics" class="selection-container">
                </div>
              </ng-container>
            </div>
            <!--end new code-->
          </ng-container>
          <ng-container *ngIf="fq.QuestionTypeId == 6 && selectedObservationPoint!=null">
            <span class="panel__header__title"><b>Observation Images</b></span>
            <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap;margin-top: 5%; ">
              <input hidden type='file' (change)="onSelectObs($event, fq)" #uploadImage>
              <ng-container>
                <div class="add-new-schematic" (click)="uploadImage.click()"
                  style="float: left; margin-right: 1%;     cursor: pointer;" matTooltip="Click to upload a image">
                  <i class="material-icons add-new-schematic__icon">add_box</i>
                  <div class="add-new-schematic__text">Add Image</div>
                </div>
                <ng-container *ngIf="obImages!=null">
                  <ng-container *ngFor="let img of obImages">
                    <img [src]="getImage(img)" class="selection__image" (click)="openEditObsImage(img)"
                      style="width: 100px;     cursor: pointer;" />
                    <mat-icon style="margin-left: 14px; cursor: pointer;"
                      (click)="deleteObsimage(img,fq)">delete</mat-icon>
                  </ng-container>
                </ng-container>
                <div id="ulSchematics" class="selection-container">
                </div>
              </ng-container>
            </div>
            <!--end new code-->
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="fq.QuestionTypeId==6">
      <ng-container *ngIf="fq.SchematicList!=null">
        <ng-container *ngFor="let img of fq.SchematicList">
          <img [src]="getImage(img.schematic_attachement)" class="selection__image"
            (click)="selectSchImage(img.schematic_attachement,img.schematic_auto)" style="width: 100px;" />
        </ng-container>
      </ng-container>
    </div>
    <!-- <div style="display: flex; justify-content:space-between; margin-top: 1%;">
      <div>
        <a *ngIf="showPrevBtn" class="button button--primary" style="background-color: white;" [class.loading]="update"
          (click)="LoadPreviousQuestion()">
          <span class="button__text" style="color: black">Previous Question</span>
        </a>
      </div>
      <div>
        <a class="button button--primary" style="background-color: white;" [class.loading]="update"
          (click)="ReturnToSummary()">
          <span class="button__text" style="color: black">Save And Return to Summary</span>
        </a>
      </div>
      <div>
        <a *ngIf="showNextBtn" class="button button--primary" style="background-color: white;" [class.loading]="update"
          (click)="LoadNextQuestion()">
          <span class="button__text" style="color: black">Save and Go to Next Question</span>
        </a>
      </div>
    </div> -->
    </div>
  </div>
  </div>
</div>
  <div class="ttmodal__footer" *ngIf="DigtalFormOverview != null">
      <button *ngIf="showPrevBtn" mat-raised-button color="warn" (click)="LoadPreviousQuestion()">
        <i class="material-icons button__icon">arrow_back</i>
        <span class="button__text">
           Previous Question
        </span>
      </button>
      <button *ngIf="!showPrevBtn" mat-raised-button color="warn" (click)="ReturnToSummary()">
        <i class="material-icons button__icon">arrow_back</i>
        <span class="button__text">
           Return to Summary
        </span>
      </button>
      <button *ngIf="!showNextBtn" mat-raised-button  class="next-btn" color="warn" (click)="ReturnToSummary()">
        <span class="button__text">
           Return to Summary
        </span>
         <i class="material-icons button__icon">arrow_forward</i>
      </button>
      <button *ngIf="showNextBtn" mat-raised-button  class="next-btn" color="warn" (click)="LoadNextQuestion()">
        <span class="button__text">
           Next Question
        </span>
        <i class="material-icons button__icon">arrow_forward</i>
      </button>
    </div>